import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { TAnyClientQuestionType } from '@hubertai/screening-question-types';

type initialQuestionSliceState = {
  questionId: string;
  visibility: string;
  updateQuestion?: TAnyClientQuestionType;
};

const initialState: initialQuestionSliceState = {
  questionId: '',
  visibility: '',
  updateQuestion: undefined,
};

const QuestionSlice = createSlice({
  name: 'Question',
  initialState,
  reducers: {
    setCurrentQuestion: (
      state,
      action: PayloadAction<{
        question: { id: string; visibility: string };
      }>,
    ) => {
      const { question } = action.payload;
      state.questionId = question.id;
      state.visibility = question.visibility;
    },
    updateQuestion: (
      state,
      action: PayloadAction<{
        question: TAnyClientQuestionType;
      }>,
    ) => {
      const { question } = action.payload;
      state.updateQuestion = question;
    },
  },
});

export const { setCurrentQuestion, updateQuestion } = QuestionSlice.actions;
export default QuestionSlice.reducer;
